<template>
  <div>
    <spinner />

    <b-modal id="modalAuthenticate" ref="modalAuthenticate" hide-footer no-close-on-backdrop no-close-on-esc>
      <div slot="modal-title" v-translate>Authenticate Shopify</div>
      <div slot="modal-header-close"></div>
      <p v-translate>Please, write down the name of your store.</p>
      <form @submit.stop.prevent="redirectAuth">
        <b-input-group size="lg" append=".myshopify.com">
          <b-form-input v-model="store" ></b-form-input>
        </b-input-group>
         <div class="text-center mt-5">
          <b-button
            type="submit"
            variant="primary"
            size="lg"
            v-translate
          >Continue</b-button>
        </div>
      </form>
    </b-modal>

    <b-modal id="modalSelectShippingType" ref="modalSelectShippingType" hide-footer no-close-on-backdrop no-close-on-esc>
      <div slot="modal-title" v-translate>Shipments Import</div>
      <div slot="modal-header-close"></div>
      <p v-translate>Please, select the shipping type for the shippings you are about to import.</p>
      <form @submit.stop.prevent="doInitCreation">
        <b-form-radio-group stacked size="xl" v-model="shippingType" :options="shippingTypeOptions" />
        <div class="text-center mt-5">
          <b-button
            type="submit"
            variant="primary"
            size="lg"
            v-translate
          >Continue</b-button>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
import Spinner from '@/components/Spinner'

export default {
  name: 'ShopifyV2RedirectPage',
  components: {
    Spinner
  },
  props: {
    type: {
      type: String,
      default: 'ongoing'
    }
  },
  computed: {
    shippingTypeOptions() {
      return [
        { text: this.$gettext('Same Day'), value: 'regular' },
        { text: this.$gettext('Next Day'), value: 'next_day' }
      ]
    }
  },
  data() {
    return {
      shippingType: 'regular',
      store: '',
      alreadyExecuted: false
    }
  },
  methods: {
    doInitCreation() {
      this.$refs.modalSelectShippingType.hide()
      this.initCreation()
    },
    async initCreation() {
      this.alreadyExecuted = true
      let listOfIds = this.$route.query['ids[]']
      let externalUserId = this.$route.query['shop']
      listOfIds = Array.isArray(listOfIds) ? listOfIds : [listOfIds]
      const payload = {
        ids: listOfIds,
        type: this.shippingType,
        store: externalUserId,
        companyId: this.$store.getters.profile.company.id,
        platformId: this.$appConfig.integrations['shopify-v2'].platformId
      }
      let result = await this.startShipments(payload)

      this.$router.push({
        name: 'integration-settings',
        query: {
          creation: true,
          shipmentsCount: listOfIds.length,
          success: result.success,
          message: result.message
        },
        params: {
          slug: 'shopify-v2'
        }
      })
    },
    getApp() {
      for (const app of this.$store.getters.profile.company.applications) {
        if (!app.webhook_url) continue
        const urlObj = new URL(app.webhook_url)
        const params = new URLSearchParams(urlObj.search)
        if (app.platform.slug === 'shopify-v2' && params.get('userId') === String(this.$store.state.auth.uid)) {
          return app
        }
      }
      return null
    },
    async startShipments(payload) {
      try {
        const app = this.getApp()
        const path = this.$appConfig.integrations.ecommerce.baseUrl + 'shopify/task-forced-orders?appId=' + app.id
        const headers = { 'x-api-key': this.$appConfig.integrations.ecommerce.header, Authorization: app.key }
        await this.$http.post(path, payload, { headers })
        return {success: 1, message: ''}
      } catch (error) {
        return {success: 0, message: error.body.message}
      }
    },
    async redirectAuth() {
      const scope = 'scope=write_orders,write_customers,write_shipping,write_fulfillments,read_locations,read_assigned_fulfillment_orders,write_returns,write_assigned_fulfillment_orders,write_merchant_managed_fulfillment_orders,read_merchant_managed_fulfillment_orders,read_products'
      const redirectUri = `${this.$appConfig.staticBaseUrl}profile/shopify-v2/integration`
      const store = this.store.replace(/https?:\/{2}|\//gi, '')
      let query = `client_id=${this.$appConfig.integrations['shopify-v2'].appId}&${scope}&redirect_uri=${redirectUri}&state=${window.location.hostname}`
      const url = `https://${store}.myshopify.com/admin/oauth/authorize?${query}`
      window.location.href = url
    }
  },
  async mounted() {
    this.$store.state.dashboard.isLoading = true
    if (this.$route.params.action === 'create-shipping') {
      this.init()
        .then(async () => {
          this.$store.state.dashboard.isLoading = false
          if (!this.$store.state.auth.uid && !this.$store.getters.profile.id) {
            this.$router.push({ name: 'login', query: {redirect: this.$route.fullPath} })
          } else {
            let nextDayEnabledSetting = this.$store.getters.profile.company.settings.find(x => x.name === 'next_day_shippings_enabled')
            if (nextDayEnabledSetting && nextDayEnabledSetting.pivot.value === '1') {
              this.$refs.modalSelectShippingType.show()
            } else if (!this.alreadyExecuted) {
              await this.initCreation()
            }
          }
        })
    } else if (this.$route.params.action === 'authenticate' && this.$route.query.shop) {
      const limit = this.$route.query.shop.indexOf('.myshopify')
      this.store = this.$route.query.shop.substr(0, limit)
      this.redirectAuth()
    } else if (this.$route.params.action === 'authenticate' && window.self === window.top) {
      this.$refs.modalAuthenticate.show()
      this.$store.state.dashboard.isLoading = false
    } else {
      console.log('pushing search')
      this.$router.push('/search')
    }
  }
}
</script>
